import { StateManager } from '../stateManager';

import { SET_MAP_DATA, SET_ORDER_RUN_DATA } from './actions';

export const initialState = {
  mapData: {},
  orderRunData: {},
};

const setMapData = (state, action) => {
  let { mapData } = action;
  return { ...state, mapData: mapData };
};

const setOrderRunData = (state, action) => {
  let { orderRunData } = action;
  return { ...state, orderRunData: orderRunData };
};

const actions = {
  [SET_MAP_DATA]: setMapData,
  [SET_ORDER_RUN_DATA]: setOrderRunData,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
